import { styled } from '@mui/material/styles';
import { AppBar, Toolbar } from '@mui/material';

export const StyledMobileNavAppBar = styled(AppBar)({
  zIndex: 1,
  backgroundColor: 'white',
  boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
  borderTopLeftRadius: '0px',
  borderBottomLeftRadius: '0px',
  borderTopRightRadius: '0px',
  borderBottomRightRadius: '0px',
});

export const StyledMobileNavToolbar = styled(Toolbar)({
  '&&': {
    minHeight: '64px',
    paddingInline: '10%',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});

export const StyledMobileNavLogo = styled('img')({
  display: 'block',
  height: '32px',
  width: 'auto',
});
